import { useMutation, useQueryClient } from "@tanstack/react-query";
import { Scene } from "@/model";
import sceneRepository from "@/repository/sceneRepository";
import { scenarioQueryKeys } from "@/query/scenario";
import { sceneKeys } from "./keys";


export const useUpdateScenes = (scenarioId: string) => {
    const queryClient = useQueryClient();

    return useMutation<Scene[], Error, FormData>({
        mutationFn: async (formData: FormData) => {
            const data = await sceneRepository.updateScenes(scenarioId, formData);
            return data.data ?? [];
        },
        onSuccess: async () => {
            await Promise.all([
                queryClient.invalidateQueries({ queryKey: sceneKeys.all(scenarioId) }),
                queryClient.invalidateQueries({ queryKey: scenarioQueryKeys.autocompletes(scenarioId) })
            ]);
        }
    });
};
